module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Glossary"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('b', [_vm._v("Glossary")]), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagex"
    }
  })]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%",
      "border-spacing": "0",
      "border-collapse": "collapse"
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "70%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("ACM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Air Chief Marshal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("AEAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Allied Expeditionary Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Air C-in-C")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Air Commander-in-Chief")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("AM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Air Marshal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("AOC; AOC-in-C")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Air Officer Commanding; Air Officer Commanding-in-Chief")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Appell")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Roll-call")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("ASC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Army Service Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("A/S/L")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Acting Squadron Leader (or A/F/L, A/W/C etc.)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("AUS, Aus")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Australia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("AVM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Air Vice-Marshal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("BAOR")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("British Army on the Rhine")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("BEF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("British Expeditionary Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("BOAC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("British Overseas Airways Corporation")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("BS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Bomber Support")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("BQMS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Battery Quarter Master Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Brigadeführer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("SS rank equivalent to Major-General ("), _c('i', [_vm._v("Generalmajor")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Bumph")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("From bum fodder (toilet paper), and so name given to paper leaflets")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("B-17")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("US 4-engined bomber built by Boeing")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("B-24")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("US 4-engined bomber built by Consolidated")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("CAN")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Canadian")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Circuit-bash(-ing)")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("To walk around the compound perimeter")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Cooler")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("PoW’s word for German punishment cell; ‘cooler’ became part of the Germans’ vocabulary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("DCM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Distinguished Conduct Medal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1",
    attrs: {
      "id": "DFC"
    }
  }, [_vm._v("DFC, DFM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Distinguished Flying Cross / Medal (‘*’ after it signifies a Bar, or second award)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("DLI")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Durham Light Infantry")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("DSC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Distinguished Service Cross")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("DSO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Companion of the Distinguished Service Order (for ‘*’ see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#DFC"
    }
  }, [_vm._v("DFC, DFM")]), _vm._v(" above)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Duff gen")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Service slang for inaccurate or poor information (opposite of ‘pukka’ gen)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("FAA")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Fleet Air Arm, Royal Navy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("FANY")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("First Aid Nursing Yeomanry. Also the unit adopted as cover by women secret agents of SOE")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Feldwebel")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Ferret")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German whose job was to ‘snoop’ around PoW camp compounds")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("F/L")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Flight Lieutenant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("F/O")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Flying Officer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("F/S")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Flight Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("FW190")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Focke Wulf 190. German single-engined fighter")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("G.A.F. or GAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German Air Force (the Luftwaffe)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Generalfeldmarschall")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Field Marshal (highest rank in the "), _c('i', [_vm._v("Wehrmacht")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Generaloberst")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Colonel-General (second highest rank in the "), _c('i', [_vm._v("Wehrmacht")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("G/C")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Group Captain")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("GI")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("General Issue. American term for the common soldier")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Goon")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("PoW slang for German guard, not necessarily, but usually, derogatory")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Gruppenführer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("SS rank equivalent to Lieutenant-General ("), _c('i', [_vm._v("Generalleutnant")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Happy valley")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("RAF aircrew slang for the Ruhr valley and its deadly defences")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("HE")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("High Explosive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Home run")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Escape from PoW camp to England (or into Allied hands)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("HT")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("High Tension, as in HT wires"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexi"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Ilag")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Short for Interniertenlager, a camp for civilian internees")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("IRCC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("International Red Cross Committee ("), _c('i', [_vm._v("Comité International de la Croix-Rouge")]), _vm._v("), whose headquarters were in Geneva, Switzerland")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("JAG")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Judge Advocate General")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Jostle")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Very powerful British airborne electronic device for jamming enemy radar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Ju88")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Junkers 88. German twin-engined bomber aircraft adapted for nightfighting")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Kiwi")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("New Zealander")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Kommandantur")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German’s quarters in PoW camp")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Kriegie")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("PoWs’ own word for themselves (from the German "), _c('i', [_vm._v("Kriegsgefangener")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Kzl.")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_c('i', [_vm._v("Konzentrationlager")]), _vm._v(", Concentration Camp")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("LAC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Leading Aircraftman")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Landwacht")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Literally “Land guard”. Roughly equivalent to the British Home Guard")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Lazarett")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Hospital")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Luftwaffe")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Me109")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German single-engined day fighter, though used at night also")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("MC, MM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Military Cross, Military Medal")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("MiD")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Mentioned in Despatches")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("MI9")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("(British) Military Intelligence, Department 9, specialising in evaders etc.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Mlle./Mme/M.")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Mademoiselle/Madame/Monsieur (Miss/Mrs/Mister – French)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("MMC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Mixed Medical Commission")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("MRAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Marshal of the Royal Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("NCO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Non-commissioned officer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Oberführer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("SS rank one below "), _c('i', [_vm._v("Brigadeführer")]), _vm._v(" but one above "), _c('i', [_vm._v("Standartenführer")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Obergruppenführer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("SS rank equivalent to General")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Oberst")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German Army rank equivalent to Colonel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Oberstleutnant")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German Army rank equivalent to Lieutenant-Colonel")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Obersturm bannführer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("SS rank equivalent to Lieutenant-Colonel ("), _c('i', [_vm._v("Oberstleutnant")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Oflag")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Short for "), _c('i', [_vm._v("Offizierenlager")]), _vm._v(", officers’ camp")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("OKW")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_c('i', [_vm._v("Oberkommand) der Wehrmacht")]), _vm._v(" (High Command of the Armed Forces)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("ORs")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Other Ranks (i.e. non-officers, but including Warrant Officers)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("OTU")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Operational Training Unit")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("PAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Polish Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("PDRC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Personnel Distribution and Reception Centre")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("‘Penguin’")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Non-aircrew, an airman without a Flying brevet (from the flightless bird)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("PFF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Pathfinder Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("P/O")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Pilot Officer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Posten")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German guard, sentry")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("PoW")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Prisoner-of-war. Usually shown in contemporary documents as P’s/W")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("PRC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Personnel Reception Centre")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("PRO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Public Record Office")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Pukka gen")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Good, reliable information (opposite of duff gen)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Purge")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Noun or verb – to move PoWs from one place to another")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("QMS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Quarter-Master Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RA")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Artillery")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RAAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Australian Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Rafale")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("French for ‘a sudden squall’ – hence ‘rapid deployment of troops’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RAMC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Army Medical Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RASC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Army Service Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RCAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Canadian Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Réseau")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("A group of the French Resistance")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RMS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Mail Ship"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagexii"
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RN")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Navy")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RNAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal Norwegian Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RNZAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Royal New Zealand Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("RSM")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Regimental Sergeant Major")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SAO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Senior Allied Officer; or Senior American Officer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SBO")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Senior British Officer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SD")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_c('i', [_vm._v("Sicherheitsdienst")]), _vm._v(" (German security agency)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SD")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Special Duties, as in squadrons of 100 (BS) Group, e.g. 199 (SD) Sq.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Second dickie")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Second pilot")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SGT, Sgt")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SHAEF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Supreme Headquarters Allied Expeditionary Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SIB")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Special Investigation Branch, RAF")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("S/L")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Squadron Leader")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SNAFU")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("S")]), _vm._v("ituation "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("N")]), _vm._v("ormal "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("A")]), _vm._v("ll "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("F")]), _vm._v("ouled "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("U")]), _vm._v("p (another word may be substituted for ‘fouled’)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SOE")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Special Operations Executive. British department fostering resistance in Europe")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Sonderführer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Literally ‘special leader’ – no direct equivalent in British forces (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/40_Appendix_XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix XI")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Sq; Sqdn")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Squadron")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("SS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_c('i', [_vm._v("Schutzstaffel")]), _vm._v(" (‘Protection Squad). Hitler’s bodyguard in the 1920s and 1930s. Later expanded as a fighting force in its own right")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Stalag")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Short for "), _c('i', [_vm._v("Stammlager")]), _vm._v(". “Stamm” has the connotation of ‘basic’, ‘lower’; hence ‘camp for other ranks’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Standartenführer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("SS rank, equivalent to Colonel in British Army")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Strafe Gefängnis")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Punishment camp or prison ("), _c('i', [_vm._v("strafe")]), _vm._v(" could mean punishment or reprisal)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Sturmann")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("SS rank, equivalent to Lance-Corporal in British Army")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("To tear off a strip")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("To severely reprimand")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("T/Sgt")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Technical Sergeant, a rank found in the US Army Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Totenliste")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Literally ‘death list’")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Unteroffizier")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Non-commissioned officer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Unterscharführer")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("SS rank, equivalent to Sergeant in British Army")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("USAAC")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("United States Army Air Corps")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("USAAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("United States Army Air Force")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("USS")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("United States Ship")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("USStAF")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("United States Strategic Air Forces")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Volkssturm")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German equivalent of the British Home Guard, i.e. men and boys not of fighting age")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Vorlager")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Area in a PoW camp between PoWs’ quarters and the "), _c('i', [_vm._v("Kommandantur")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("WAG")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Wireless Operator/Air Gunner")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("W/C")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Wing Commander")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Wehrkreis")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Administrative area within the German Reich (see "), _c('span', {
    attrs: {
      "href": "#/xhtml/31_Appendix_II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Wehrmacht")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("German Army")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("Window")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Code name given to strips of metal paper thrown from bombers to confuse German radar")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("W/O")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Warrant Officer")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_vm._v("WO1/WO2")])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Warrant Officer First Class/Second Class")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para1"
  }, [_c('i', [_vm._v("Zuchthaus")])])]), _vm._v(" "), _c('td', {
    staticClass: "td"
  }, [_c('p', {
    staticClass: "glo-para2"
  }, [_vm._v("Prison")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-172dfe08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Glossary.vue
// module id = 75
// module chunks = 0